import { Text } from "@chakra-ui/react";
import { ContractTaskDto, ContractTaskResponsiblePartyDto } from "../../../../autogen/bff-api";
import { displayPersonName } from "../sharing/AddExternalParticipantModal";
interface Props {
  task: ContractTaskDto;
  size?: "sm" | "md" | "lg";
}

export const ContractTaskResponsibleParty = ({ task }: Props) => {
  switch (task.responsibleParty) {
    case ContractTaskResponsiblePartyDto.Organization: {
      const organization = task.responsibleOrganization;
      if (!organization) {
        throw new Error("Should never happen");
      }
      return <Text fontSize={"sm"}>{organization.name}</Text>;
    }
    case ContractTaskResponsiblePartyDto.PersonInOrganization: {
      const person = task.responsiblePerson;
      if (!person) {
        throw new Error("Should never happen");
      }
      return <Text fontSize={"sm"}>{displayPersonName(person)}</Text>;
    }
  }
};
